import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { API } from "../global/global";

export const useDeleteImage = () => {
  const authContext = useContext(AuthContext);

  const deleteImage = async (idActividad: number, nombreArchivo: string) => {
    try {
      const response = await fetch(
        `${API}/foto/${idActividad}/${nombreArchivo}`,
        {
          method: "DELETE",
          headers: {
            Authorization: "Bearer " + authContext.token,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error al eliminar la imagen");
      }

      const data = await response.json();
      return { success: true, message: data.message };
    } catch (error) {
      return { success: false, message: "Error al eliminar la imagen" };
    }
  };

  return { deleteImage };
};
